module.exports = __webpack_public_path__ + "static/media/3DPPA11.184222c6.jpg";